// ══════════════════════════════════════════════
// IQ KUNSTUITLEEN — Favorieten / Wishlist (2026-07-27, v2)
// Opgeslagen in localStorage als {id, handle}-objecten.
// BUGFIX: eerst alleen ID's opgeslagen, en de dropdown
// gebruikte /products.json?limit=250 om favorieten te
// vinden - dat toont maar de eerste 250 van 1300+
// producten, dus favorieten buiten die 250 werden nooit
// gevonden. Nu per favoriet een directe fetch naar
// /products/{handle}.js, wat altijd werkt ongeacht het
// totaal aantal producten in de winkel.
// ══════════════════════════════════════════════
(function () {
  var OPSLAG_KEY = 'iq_favorieten';

  function haalFavorieten() {
    try {
      var ruw = localStorage.getItem(OPSLAG_KEY);
      var data = ruw ? JSON.parse(ruw) : [];
      // Migratie: oude opslag was een platte lijst van id's (strings).
      // Zet die om naar het nieuwe {id, handle}-formaat waar mogelijk.
      if (data.length && typeof data[0] === 'string') {
        data = data.map(function (id) { return { id: id, handle: null }; });
      }
      return data;
    } catch (e) {
      return [];
    }
  }

  function slaFavorietenOp(lijst) {
    try {
      localStorage.setItem(OPSLAG_KEY, JSON.stringify(lijst));
    } catch (e) {}
  }

  function vindIndex(lijst, id) {
    for (var i = 0; i < lijst.length; i++) {
      if (String(lijst[i].id) === String(id)) return i;
    }
    return -1;
  }

  function werkTellerBij() {
    var lijst = haalFavorieten();
    var badges = document.querySelectorAll('.iq-fav-count-badge');
    badges.forEach(function (badge) {
      badge.textContent = lijst.length;
      badge.setAttribute('data-count', lijst.length);
    });
  }

  function werkKnoppenBij() {
    var lijst = haalFavorieten();
    var knoppen = document.querySelectorAll('.iq-favorite-btn, .iq-favorite-btn-v2');
    knoppen.forEach(function (knop) {
      var id = knop.getAttribute('data-product-id');
      if (vindIndex(lijst, id) > -1) {
        knop.classList.add('is-favorite');
      } else {
        knop.classList.remove('is-favorite');
      }
    });
  }

  window.iqToggleFavorite = function (knop) {
    var id = String(knop.getAttribute('data-product-id'));
    var handle = knop.getAttribute('data-product-handle') || null;
    var lijst = haalFavorieten();
    var index = vindIndex(lijst, id);
    if (index > -1) {
      lijst.splice(index, 1);
    } else {
      lijst.push({ id: id, handle: handle });
    }
    slaFavorietenOp(lijst);
    werkKnoppenBij();
    werkTellerBij();
    vulDropdown();
  };

  async function vulDropdown() {
    var lijstEl = document.getElementById('iq-fav-dropdown-list');
    var leegEl = document.getElementById('iq-fav-dropdown-empty');
    if (!lijstEl) return;

    var favorieten = haalFavorieten();
    if (!favorieten.length) {
      lijstEl.innerHTML = '';
      if (leegEl) leegEl.style.display = 'block';
      return;
    }
    if (leegEl) leegEl.style.display = 'none';

    lijstEl.innerHTML = '<p style="text-align:center;color:#767676;font-size:13px;padding:10px 0;">Laden...</p>';

    var kaarten = await Promise.all(favorieten.map(async function (fav) {
      if (!fav.handle) return null;
      try {
        var resp = await fetch('/products/' + fav.handle + '.js');
        if (!resp.ok) return null;
        var p = await resp.json();
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_100x$1$2') : '';
        var titleParts = (p.title || '').split(' — ');
        var artist = titleParts[0] || p.vendor || '';
        var title = titleParts[1] || p.title || '';
        return '<a href="/products/' + p.handle + '" class="iq-fav-dropdown-item">' +
          '<img src="' + img + '" alt="" loading="lazy">' +
          '<div class="iq-fav-dropdown-item-info">' +
          '<div class="iq-fav-dropdown-item-artist">' + artist.replace(/</g, '') + '</div>' +
          '<div class="iq-fav-dropdown-item-title">' + title.replace(/</g, '') + '</div>' +
          '</div></a>';
      } catch (e) {
        return null;
      }
    }));

    var html = kaarten.filter(Boolean).join('');
    lijstEl.innerHTML = html || '';
    if (!html && leegEl) leegEl.style.display = 'block';
  }

  window.iqToggleFavDropdown = function (event) {
    event.preventDefault();
    event.stopPropagation();
    var dropdown = document.getElementById('iq-fav-dropdown');
    if (!dropdown) return;
    var wasOpen = dropdown.classList.contains('open');
    dropdown.classList.toggle('open');
    if (!wasOpen) {
      vulDropdown();
    }
  };

  document.addEventListener('click', function (e) {
    var dropdown = document.getElementById('iq-fav-dropdown');
    var wrap = document.querySelector('.iq-fav-dropdown-wrap');
    if (dropdown && dropdown.classList.contains('open') && wrap && !wrap.contains(e.target)) {
      dropdown.classList.remove('open');
    }
  });

  function init() {
    werkKnoppenBij();
    werkTellerBij();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var observer = new MutationObserver(function () {
    werkKnoppenBij();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
